import { z } from 'zod'

import { DateZod, GeoPointZod } from '../../common'

export const GeolocationZod = z.object({
  geolocation: GeoPointZod,
  timestamp: DateZod,
})

export const TeamLocationZod = GeolocationZod.extend({
  transportRequestId: z.string().optional(),
})
